import * as React from "react"
import { Facebook, Linkedin } from "react-bootstrap-icons"
export default function Footer() {
  return (
    <footer className="py-2 bg-secondary">
      <p className="text-center text-light mt-4">Review collection service provided by <a className="text-light" href="https://www.webhq.uk/review-management/" target="_blank">WebHQ</a></p>
    </footer>
  )
}
